import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer>
      <p className="footer-text">
        © 2026 vWZZ. For flight simulation purposes only. Not affiliated with Wizz Air Holdings Plc.
        <Link to="/privacy" className="footer-link">Privacy Policy</Link>
      </p>
    </footer>
  );
}
